import * as CoreWatch from '@dynamicore/corewatch';

import {
  API_CONTEXT,
  API_URL,
  BUILD_VERSION,
} from 'settings';
import { getCurrentSessionData } from 'utils/aws/cognito';

const isDevelopment = process.env.NODE_ENV !== 'production';

CoreWatch.init({
  // Groups events per app in the CoreWatch panel (one project, many companies).
  project: 'core-panel',
  environment: process.env.NODE_ENV,
  release: BUILD_VERSION,
  debug: isDevelopment,
  // Session user resolved at send time (login can happen after init).
  beforeSend: (event) => {
    const { decodeAccessToken } = getCurrentSessionData();

    if (decodeAccessToken) {
      event.user = {
        ...(event.user || {}),
        id: decodeAccessToken.sub,
        username: decodeAccessToken.username,
      };
    }

    return event;
  },
  transports: [
    ...(isDevelopment ? [CoreWatch.createConsoleTransport()] : []),
    CoreWatch.createHttpTransport({
      baseUrl: API_URL,
      // Same headers as utils/axios.js
      authorization: () => getCurrentSessionData().accessToken,
      context: API_CONTEXT,
      debug: isDevelopment,
    }),
  ],
});
